<template>
  <div>
    <a class="propfilter-btn" @click="is_active = !is_active">
      <img src="@/assets/icons/filter.svg"
        v-tooltip="{ content: localization('app-filter-features', 'Filter Features'), placement: 'top-center' }" />
    </a>
    <div class="extra-properties-filters card" v-if="is_active" style="border-radius:6px;">
      <div class="card-header">
        <div class="card-header-title">
          {{ localization("app-filters", "filters") }}
          <a class="button is-small init-filter" :class="{ 'is-loading': is_loading }">
            <i @click="init_filters" class="fa fa-sync is-size-7"></i>
          </a>
        </div>
        <div class="card-header-icon">
          <a class="filter-btn" @click="is_active = !is_active">
            <i class="fa" :class="{ 'fa-filter': !is_active, 'fa-times': is_active }"></i>
          </a>
        </div>
      </div>
      <div class="card-content">
        <div class="content" style="padding:0">
          <div class="field">
            <label class="label c-field-label">{{ localization("app-property", "Property") }}</label>
            <b-select @input="
              selected_values = [];
            update_values();
            " v-model="selected_key" expanded :placeholder="localization('app-select-property', 'Select Property')">
              <option v-for="k of Object.keys(keys)" :key="k">{{ k }}</option>
            </b-select>
          </div>
          <b-field custom-class="c-field-label" :label="localization('app-values', 'Values')">
            <treeselect :multiple="true" :options="values" :normalizer="normalizer"
              :placeholder="localization('app-select-values', 'Select Values')" v-model="selected_values" />
          </b-field>
          <a @click="apply" class="button is-fullwidth is-semibold-16-600-19 is-info">{{
            localization("app-apply-filters", "Apply Filters")
            }}</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      is_loading: false,
      is_active: 0,
      keys: {},
      values: [],
      selected_key: null,
      selected_values: [],
    };
  },
  computed: {
    ...mapState(["draw", "active_projects"]),
  },
  watch: {
    is_active: function (val) {
      if (val && !Object.keys(this.keys).length) this.init_filters();
    },
  },
  methods: {
    ...mapMutations(["SET_EXTRA_PROPS_FILTER", "FILTER_FEATURES_BY_EXTRAPROPS"]),
    apply() {
      let castedValues = this.selected_values.filter((val) => val.constructor == String);
      castedValues = castedValues.map((val) => Number(val));
      castedValues = castedValues.filter((val) => val);
      this.FILTER_FEATURES_BY_EXTRAPROPS({
        key: this.selected_key,
        values: [...this.selected_values, ...castedValues],
      });
    },
    update_values() {
      this.is_loading = true;
      new Promise((resolve, reject) => {
        let all_values = {};
        if (this.selected_key && this.draw)
          this.draw.getAll().features.forEach((f) => {
            if (f.properties.extraProperties && f.properties.extraProperties[this.selected_key]) {
              all_values[f.properties.extraProperties[this.selected_key]] = 1;
            }
          });
        resolve(Object.keys(all_values));
      }).then((res) => {
        this.values = res;
        this.is_loading = false;
      });
    },
    init_filters() {
      this.is_loading = true;
      new Promise((resolve, reject) => {
        this.draw.getAll().features.forEach((f) => {
          if (f.properties.extraProperties) {
            this.keys = {
              ...this.keys,
              ...(f.properties.extraProperties || {}),
            };
          }
        });
        resolve(true);
      }).then((res) => {
        setTimeout(() => {
          this.update_values();
          this.is_loading = false;
        }, 1000);
      });
    },
    normalizer(node) {
      return {
        id: node,
        label: node,
      };
    },
  },
};
</script>
<style lang="scss">
.propfilter-btn {
  position: fixed;
  right: 8.8rem;
  top: 2.2rem;
  z-index: 40 !important;
}

.extra-properties-filters {
  .card-header {
    box-shadow: none;

    .card-header-title {
      font-family: Barlow-bold;
      color: #171e48;
      padding-left: 1.5rem;

      .init-filter {
        border: 0;
        box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
        opacity: 0.7;
        margin-left: 6px;
        border-radius: 4px;
      }
    }
  }

  .card-content {
    padding-top: 0.5rem;
  }
}

.extra-properties-filters {
  position: fixed;
  right: 10.5rem;
  top: 1.2rem;
  z-index: 40 !important;

  .content {
    width: 15rem;
    background: white;
    // padding: 0.75rem;
    // margin: 4px;
    position: relative;
  }

  .filter-btn {
    position: absolute;
    right: 12px;
    top: 15px;
    z-index: 1;
    margin-right: 0.5rem;
    color: #171e48;
  }

  .c-field-label {
    display: flex;
    align-items: center;
    font-family: Barlow-medium;
    font-size: 14px;
    font-weight: 500;
    text-align: left;
    color: #171e48;
  }

  .select select,
  input {
    border: 0;
    border-bottom: 1px solid;
    border-radius: 0;
    border-color: #dddddd;
    box-shadow: none;
  }

  .cancel-btn {
    border: none;
    box-shadow: none;
  }

  .vue-treeselect__control {
    border: 0;
  }
}
</style>
